import React from "react";
import { SvgIcon } from "@material-ui/core";

export const Svg = (patch) => {
    switch (patch) {
        case "fileExclamation":
            return (
                <SvgIcon
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="file-exclamation"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    class="svg-inline--fa fa-file-exclamation fa-w-12 "
                    style={{ fontSize: "16px" }}
                >
                    <path
                        fill="currentColor"
                        d="M384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9zm0 38.1v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24h136zm-231.2 60.8l7.2 112c.4 6.3 5.6 11.2 12 11.2h40c6.3 0 11.6-4.9 12-11.2l7.2-112c.4-6.9-5-12.8-12-12.8h-54.4c-6.9 0-12.4 5.8-12 12.8zM232 400c0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40 40-17.9 40-40z"
                        class=""
                    ></path>{" "}
                </SvgIcon>
            );

        default:
            break;
    }
};
